import React, { ReactNode } from 'react';
import { TitleAndValue } from '../UI-Elements/TitlesAndTexts/TitleAndValueList';
import { ToolTipCircle } from '../UI-Elements/ToolTipCircle';
import { IRouteIconCell, RouteIconCell } from './RouteMetricCardsComponents/RouteIconCell';
import { Tooltip } from '@mui/material';

const DELETE_ICON_LOCATION = './assets/icons/blue-flat/delete.svg';
// const IS_PICKED_BORDER_COLOR = '#FD4C7C';
const BORDER_COLOR = '#EAEAEB';

interface Props {
  id?: string;
  title: string;
  subTitle: string;
  routeColor: string;
  titleWithValue: { title: string; valueAsString: string }[];
  toolTipText?: string;
  deleteRouteOption?: () => void;
  iconCellList: IRouteIconCell[];
  isPicked?: boolean;
  onClickOnRoute?: () => void;
  children?: ReactNode;
  showMoreInfo?: () => void;
}

export const RouteMetricCards: React.FC<Props> = ({
  iconCellList,
  subTitle,
  title,
  routeColor,
  titleWithValue,
  id,
  toolTipText,
  deleteRouteOption,
  isPicked = false,
  onClickOnRoute = () => {},
  children,
  showMoreInfo,
}) => {
  return (
    <div
      onClick={onClickOnRoute}
      className={`flex flex-1 p-2 gap-3 items-center align-center overflow-y-hidden cursor-pointer h-20 ${
        isPicked ? 'shadow-custom' : ''
      }`}
      style={{
        borderRight: `2px solid ${isPicked ? routeColor : BORDER_COLOR}`,
        borderTop: `2px solid ${isPicked ? routeColor : BORDER_COLOR}`,
        borderBottom: `2px solid ${isPicked ? routeColor : BORDER_COLOR}`,
        borderLeft: `0.5rem solid ${routeColor || BORDER_COLOR}`,
      }}
    >
      <div className="flex gap-3 overflow-hidden *max-w-[40%] ">
        {id && <p className={`text-lg font-semibold mb-auto ${isPicked ? 'text-red-300' : 'text-black'}`}>{id}</p>}
        <div className="space-y-[0.5rem] overflow-hidden">
          <Tooltip title={title}>
            <p className="text-base font-medium truncate">{title}</p>
          </Tooltip>
          <Tooltip title={subTitle}>
            <p className="text-sm text-secondary_text opacity-80 truncate">{subTitle}</p>
          </Tooltip>
        </div>
      </div>
      <div className="px-1 flex align-bottom justify-self-end">
        <RouteIconCell routeIconCellData={iconCellList} />
      </div>
      <div className="flex space-x-[1.5rem] ms-auto ">
        <TitleAndValue titleValueData={titleWithValue} />
      </div>
      <div className="flex space-x-[0.5rem] ">
        {deleteRouteOption && (
          <button onClick={deleteRouteOption} className="">
            <img title="Delete" src={DELETE_ICON_LOCATION} />
          </button>
        )}
        {toolTipText && (
          <div className="my-auto cursor-pointer" onClick={showMoreInfo}>
            <ToolTipCircle text={toolTipText} lgSize="2xl" xlgSize="3xl" />
          </div>
        )}
      </div>
      {children && <div>{children}</div>}
    </div>
  );
};
